import {Advice} from '@antv/ava';

// 格式转换
const pieAdvisorToEcharts = (advice: Advice) => {
    const { spec: { encode, data } } = advice;
    const chartData = data.map((item: any) => {
        return {
            value: item[encode.y],
            name: item[encode.color]
        }
    });
    return {
        tooltip: {
            trigger: 'item'
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        legend: {
            type: 'scroll',
            orient: 'horizontal',
            left: 'left'
        },
        series: [
            {
                type: 'pie',
                radius: '60%',
                top: '10%',
                data: chartData,
                emphasis: {
                    itemStyle: {
                        shadowBlur: 10,
                        shadowOffsetX: 0,
                        shadowColor: 'rgba(0, 0, 0, 0.5)'
                    }
                }
            }
        ]
    }
}

const donutAdvisorToEcharts = (advice: Advice) => {
    const { spec: { encode, data } } = advice;
    const chartData = data.map((item: any) => {
        return {
            value: item[encode.y],
            name: item[encode.color]
        }
    });
    return {
        tooltip: {
            trigger: 'item'
        },
        legend: {
            type: 'scroll',
            left: 'left'
        },
        series: [
            {
                type: 'pie',
                radius: ['40%', '70%'],
                avoidLabelOverlap: false,
                label: {
                    show: false,
                    position: 'center'
                },
                labelLine: {
                    show: false
                },
                data: chartData
            }
        ]
    }
}

const lineAdvisorToEcharts = (advice: Advice) => {
    const { spec: { children, data } } = advice;
    const xAxisData = data.map((item: any) => item[children[0].encode.x]);
    const legendData = children.map((child: any) => child.encode.color());
    const seriesData = children.map((child: any) => {
        return {
            name: child.encode.color(),
            type: 'line',
            data: data.map((item: any) => item[child.encode.y])
        }
    })
    return  {
        tooltip: {
            trigger: 'axis'
        },
        legend: {
            data: legendData,
            left: 'left'
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            boundaryGap: false,
            data: xAxisData
        },
        yAxis: {
            type: 'value'
        },
        series: seriesData
    };
}

const barAdvisorToEcharts = (advice: Advice) => {
    const { spec: { children, data } } = advice;
    const xAxisData = data.map((item: any) => item[children[0].encode.x]);
    const legendData = children.map((child: any) => child.encode.color());
    const seriesData = children.map((child: any) => {
        return {
            name: child.encode.color(),
            type: 'bar',
            data: data.map((item: any) => item[child.encode.y])
        }
    })
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            data: legendData,
            left: 'left'
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: [
            {
                type: 'category',
                data: xAxisData
            }
        ],
        yAxis: [
            {
                type: 'value'
            }
        ],
        series: seriesData
    }
}

const singleBarAdvisorToEcharts = (advice: Advice) => {
    const { spec: { encode, data } } = advice;
    const xAxisData = data.map((item: any) => item[encode.x]);
    const seriesData = data.map((item: any) => item[encode.y]);

    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            left: 'left'
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
            type: 'category',
            data: xAxisData
        },
        yAxis: {
            type: 'value'
        },
        series: {
            data: seriesData,
            type: 'bar',
            name: encode.x
        }
    }
}

const transformBarAdvisorToEcharts = (advice: Advice) => {
    const { spec: { encode, data } } = advice;
    const xAxisData = data.map((item: any) => item[encode.x]);
    const seriesData = data.map((item: any) => item[encode.y]);

    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                type: 'shadow'
            }
        },
        legend: {
            left: 'left'
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
            type: 'value'
        },
        yAxis: {
            type: 'category',
            data: xAxisData
        },
        series: {
            data: seriesData,
            type: 'bar',
            name: encode.x
        }
    }
}

const scatterAdvisorToEcharts = (advice: Advice) => {
    const { spec: { encode, data } } = advice;
    const chartData = data.map((item: any) => {
        return [
            item[encode.x],
            item[encode.y],
            item[encode.color],
        ]
    });
    const seriesData = chartData.map((item: any) => {
        return {
            zlevel: 1,
            name: item[2],
            type: 'scatter',
            data: [item],
            animationThreshold: 5000,
            progressiveThreshold: 5000
        }
    })
    const legendData = data.map((item: any) => item[encode.color]);

    return {
        legend: {
            data: legendData,
            left: 'left'
        },
        grid: {
            left: '5%',
            right: '5%',
            bottom: '5%',
            containLabel: true
        },
        xAxis: {
            name: encode.x,
            splitLine: { show: false }
        },
        yAxis: {
            name: encode.y,
            splitLine: { show: false }
        },
        tooltip: {
            trigger: 'item',
            formatter: (params: any) => {
                return `${encode.color}: ${params.data[2]}<br>${encode.x}: ${params.data[0]}<br>${encode.y}: ${params.data[1]}`
            }
        },
        series: seriesData,
        animationEasingUpdate: 'cubicInOut',
        animationDurationUpdate: 2000
    }
}

const heatmapAdvisorToEcharts = (advice: Advice) => {}

const areaAdvisorToEcharts = (advice: Advice) => {}

export const advisorEchartsMap = {
    'pie_chart': pieAdvisorToEcharts,
    'multi_measure_line_chart': lineAdvisorToEcharts,
    'multi_measure_column_chart': barAdvisorToEcharts,
    'column_chart': singleBarAdvisorToEcharts,
    'bar_chart': transformBarAdvisorToEcharts,
    'scatter_plot': scatterAdvisorToEcharts,
    'donut_chart': donutAdvisorToEcharts,
    'heatmap': heatmapAdvisorToEcharts,
    'area_chart': areaAdvisorToEcharts,
}

